import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ServiceCollaboration} from './service-collaboration.model';
import * as ServiceCollaborationActions from './service-collaboration.actions';

export const serviceCollaborationsFeatureKey = 'serviceCollaborations';

export interface State extends EntityState<ServiceCollaboration> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ServiceCollaboration> = createEntityAdapter<ServiceCollaboration>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ServiceCollaborationActions.addServiceCollaboration,
    (state, action) => adapter.addOne(action.serviceCollaboration, state)
  ),
  on(ServiceCollaborationActions.upsertServiceCollaboration,
    (state, action) => adapter.upsertOne(action.serviceCollaboration, state)
  ),
  on(ServiceCollaborationActions.addServiceCollaborations,
    (state, action) => adapter.addMany(action.serviceCollaborations, state)
  ),
  on(ServiceCollaborationActions.upsertServiceCollaborations,
    (state, action) => adapter.upsertMany(action.serviceCollaborations, state)
  ),
  on(ServiceCollaborationActions.updateServiceCollaboration,
    (state, action) => adapter.updateOne(action.serviceCollaboration, state)
  ),
  on(ServiceCollaborationActions.updateServiceCollaborations,
    (state, action) => adapter.updateMany(action.serviceCollaborations, state)
  ),
  on(ServiceCollaborationActions.deleteServiceCollaboration,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ServiceCollaborationActions.deleteServiceCollaborations,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ServiceCollaborationActions.loadServiceCollaborations,
    (state, action) => adapter.setAll(action.serviceCollaborations, state)
  ),
  on(ServiceCollaborationActions.clearServiceCollaborations,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
